var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#camera_icon_circle_svg__filter0_d_9809_2542)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 11.5,
    fill: "#fff",
    fillOpacity: 0.8,
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.075 17.908c.219-.219.342-.515.342-.825v-6.416A1.167 1.167 0 0019.25 9.5h-2.333L15.75 7.75h-3.5L11.083 9.5H8.75a1.167 1.167 0 00-1.167 1.167v6.416A1.167 1.167 0 008.75 18.25h10.5c.31 0 .606-.123.825-.342zm-7.908-4.325a1.833 1.833 0 113.666 0 1.833 1.833 0 01-3.666 0zM14 10.75a2.833 2.833 0 100 5.667 2.833 2.833 0 000-5.667z",
    fill: "#000",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "camera_icon_circle_svg__filter0_d_9809_2542",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9809_2542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9809_2542",
    result: "shape"
  })))));
}
export default SvgCameraIconCircle;